/* @generated from adl module myc.scoring.api */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as common_http from './../../common/http';
import * as common_strings from './../../common/strings';
import * as common_tabular from './../../common/tabular';
import * as myc_scoring_db from './db';

export interface ApiRequests {
  /**
   * Login a user
   */
  login: common_http.HttpPost<LoginReq, LoginResp>;
  /**
   * Gets the logged in user details
   */
  whoAmI: common_http.HttpGet<UserProfile>;
  seasons: common_http.HttpGet<SeasonDetails[]>;
  raceSchedule: common_http.HttpPost<myc_scoring_db.SeasonId, RaceScheduleResp>;
  /**
   * Fetch the entrants for a race
   */
  getRaceEntrants: common_http.HttpPost<myc_scoring_db.RaceId, RaceEntrant[]>;
  /**
   * Fetch the results for a race
   */
  getRaceResults: common_http.HttpPost<myc_scoring_db.RaceId, GetRaceResultsResp>;
  /**
   * Set/update the results for a race
   */
  updateRaceResults: common_http.HttpPost<UpdateRaceResultsReq, common.Unit>;
  /**
   * Fetch results for an event
   */
  getEventResults: common_http.HttpPost<myc_scoring_db.EventId, GetEventResultsResp>;
  /**
   * Fetch results for all events in a season
   */
  getSeasonEventResults: common_http.HttpPost<myc_scoring_db.SeasonId, EventResults[]>;
  /**
   * Fetch results for a series
   */
  getSeriesResults: common_http.HttpPost<myc_scoring_db.SeriesId, GetSeriesResultsResp>;
  /**
   * Create a new user
   */
  createUser: common_http.HttpPost<UserReq, myc_scoring_db.AppUserId>;
  /**
   * Update an existing user
   */
  updateUser: common_http.HttpPost<common_db.WithDbId<UserReq>, common.Unit>;
  /**
   * Change the password for an existing user
   */
  setUserPassword: common_http.HttpPost<SetPasswordReq, SetPasswordResp>;
  /**
   * Delete an existing user
   */
  deleteUser: common_http.HttpPost<myc_scoring_db.AppUserId, common.Unit>;
  /**
   * Query existing users sorted and filters according to the
   * TableQuery request.
   */
  queryUsers: common_http.HttpPost<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<myc_scoring_db.AppUser>>>;
}

export function makeApiRequests(
  input: {
    login?: common_http.HttpPost<LoginReq, LoginResp>,
    whoAmI?: common_http.HttpGet<UserProfile>,
    seasons?: common_http.HttpGet<SeasonDetails[]>,
    raceSchedule?: common_http.HttpPost<myc_scoring_db.SeasonId, RaceScheduleResp>,
    getRaceEntrants?: common_http.HttpPost<myc_scoring_db.RaceId, RaceEntrant[]>,
    getRaceResults?: common_http.HttpPost<myc_scoring_db.RaceId, GetRaceResultsResp>,
    updateRaceResults?: common_http.HttpPost<UpdateRaceResultsReq, common.Unit>,
    getEventResults?: common_http.HttpPost<myc_scoring_db.EventId, GetEventResultsResp>,
    getSeasonEventResults?: common_http.HttpPost<myc_scoring_db.SeasonId, EventResults[]>,
    getSeriesResults?: common_http.HttpPost<myc_scoring_db.SeriesId, GetSeriesResultsResp>,
    createUser?: common_http.HttpPost<UserReq, myc_scoring_db.AppUserId>,
    updateUser?: common_http.HttpPost<common_db.WithDbId<UserReq>, common.Unit>,
    setUserPassword?: common_http.HttpPost<SetPasswordReq, SetPasswordResp>,
    deleteUser?: common_http.HttpPost<myc_scoring_db.AppUserId, common.Unit>,
    queryUsers?: common_http.HttpPost<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<myc_scoring_db.AppUser>>>,
  }
): ApiRequests {
  return {
    login: input.login === undefined ? {path : "/login", security : {kind : "public"}, reqType : texprLoginReq(), respType : texprLoginResp()} : input.login,
    whoAmI: input.whoAmI === undefined ? {path : "/whoami", security : {kind : "token"}, respType : texprUserProfile()} : input.whoAmI,
    seasons: input.seasons === undefined ? {path : "/seasons", security : {kind : "public"}, respType : ADL.texprVector(texprSeasonDetails())} : input.seasons,
    raceSchedule: input.raceSchedule === undefined ? {path : "/race-schedule", security : {kind : "public"}, reqType : myc_scoring_db.texprSeasonId(), respType : texprRaceScheduleResp()} : input.raceSchedule,
    getRaceEntrants: input.getRaceEntrants === undefined ? {path : "/raceentrants-get", security : {kind : "public"}, reqType : myc_scoring_db.texprRaceId(), respType : ADL.texprVector(texprRaceEntrant())} : input.getRaceEntrants,
    getRaceResults: input.getRaceResults === undefined ? {path : "/results/race", security : {kind : "public"}, reqType : myc_scoring_db.texprRaceId(), respType : texprGetRaceResultsResp()} : input.getRaceResults,
    updateRaceResults: input.updateRaceResults === undefined ? {path : "/results/race/update", security : {kind : "token"}, reqType : texprUpdateRaceResultsReq(), respType : common.texprUnit()} : input.updateRaceResults,
    getEventResults: input.getEventResults === undefined ? {path : "/results/event", security : {kind : "public"}, reqType : myc_scoring_db.texprEventId(), respType : texprGetEventResultsResp()} : input.getEventResults,
    getSeasonEventResults: input.getSeasonEventResults === undefined ? {path : "/results/season-events", security : {kind : "public"}, reqType : myc_scoring_db.texprSeasonId(), respType : ADL.texprVector(texprEventResults())} : input.getSeasonEventResults,
    getSeriesResults: input.getSeriesResults === undefined ? {path : "/results/series", security : {kind : "public"}, reqType : myc_scoring_db.texprSeriesId(), respType : texprGetSeriesResultsResp()} : input.getSeriesResults,
    createUser: input.createUser === undefined ? {path : "/users/create", security : {kind : "tokenWithRole", value : "admin"}, reqType : texprUserReq(), respType : myc_scoring_db.texprAppUserId()} : input.createUser,
    updateUser: input.updateUser === undefined ? {path : "/users/update", security : {kind : "tokenWithRole", value : "admin"}, reqType : common_db.texprWithDbId(texprUserReq()), respType : common.texprUnit()} : input.updateUser,
    setUserPassword: input.setUserPassword === undefined ? {path : "/users/set-password", security : {kind : "tokenWithRole", value : "admin"}, reqType : texprSetPasswordReq(), respType : texprSetPasswordResp()} : input.setUserPassword,
    deleteUser: input.deleteUser === undefined ? {path : "/users/delete", security : {kind : "tokenWithRole", value : "admin"}, reqType : myc_scoring_db.texprAppUserId(), respType : common.texprUnit()} : input.deleteUser,
    queryUsers: input.queryUsers === undefined ? {path : "/users/query", security : {kind : "tokenWithRole", value : "admin"}, reqType : common_tabular.texprTableQuery(), respType : common.texprPaginated(common_db.texprWithDbId(myc_scoring_db.texprAppUser()))} : input.queryUsers,
  };
}

const ApiRequests_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Login a user\n"}],"serializedName":"login","default":{"kind":"just","value":{"path":"/login","security":"public"}},"name":"login","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"LoginReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"LoginResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Gets the logged in user details\n"}],"serializedName":"whoAmI","default":{"kind":"just","value":{"path":"/whoami","security":"token"}},"name":"whoAmI","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpGet"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"UserProfile"}},"parameters":[]}]}},{"annotations":[],"serializedName":"seasons","default":{"kind":"just","value":{"path":"/seasons","security":"public"}},"name":"seasons","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpGet"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"SeasonDetails"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"raceSchedule","default":{"kind":"just","value":{"path":"/race-schedule","security":"public"}},"name":"raceSchedule","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"SeasonId"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"RaceScheduleResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Fetch the entrants for a race\n"}],"serializedName":"getRaceEntrants","default":{"kind":"just","value":{"path":"/raceentrants-get","security":"public"}},"name":"getRaceEntrants","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"RaceId"}},"parameters":[]},{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"RaceEntrant"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Fetch the results for a race\n"}],"serializedName":"getRaceResults","default":{"kind":"just","value":{"path":"/results/race","security":"public"}},"name":"getRaceResults","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"RaceId"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"GetRaceResultsResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Set/update the results for a race\n"}],"serializedName":"updateRaceResults","default":{"kind":"just","value":{"path":"/results/race/update","security":"token"}},"name":"updateRaceResults","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"UpdateRaceResultsReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Fetch results for an event\n"}],"serializedName":"getEventResults","default":{"kind":"just","value":{"path":"/results/event","security":"public"}},"name":"getEventResults","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"EventId"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"GetEventResultsResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Fetch results for all events in a season\n"}],"serializedName":"getSeasonEventResults","default":{"kind":"just","value":{"path":"/results/season-events","security":"public"}},"name":"getSeasonEventResults","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"SeasonId"}},"parameters":[]},{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"EventResults"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Fetch results for a series\n"}],"serializedName":"getSeriesResults","default":{"kind":"just","value":{"path":"/results/series","security":"public"}},"name":"getSeriesResults","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"SeriesId"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"GetSeriesResultsResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Create a new user\n"}],"serializedName":"createUser","default":{"kind":"just","value":{"path":"/users/create","security":{"tokenWithRole":"admin"}}},"name":"createUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"UserReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"AppUserId"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Update an existing user\n"}],"serializedName":"updateUser","default":{"kind":"just","value":{"path":"/users/update","security":{"tokenWithRole":"admin"}}},"name":"updateUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"UserReq"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Change the password for an existing user\n"}],"serializedName":"setUserPassword","default":{"kind":"just","value":{"path":"/users/set-password","security":{"tokenWithRole":"admin"}}},"name":"setUserPassword","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"SetPasswordReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"SetPasswordResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Delete an existing user\n"}],"serializedName":"deleteUser","default":{"kind":"just","value":{"path":"/users/delete","security":{"tokenWithRole":"admin"}}},"name":"deleteUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"AppUserId"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Query existing users sorted and filters according to the\nTableQuery request.\n"}],"serializedName":"queryUsers","default":{"kind":"just","value":{"path":"/users/query","security":{"tokenWithRole":"admin"}}},"name":"queryUsers","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.tabular","name":"TableQuery"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Paginated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"AppUser"}},"parameters":[]}]}]}]}}]}},"name":"ApiRequests","version":{"kind":"nothing"}}};

export const snApiRequests: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"ApiRequests"};

export function texprApiRequests(): ADL.ATypeExpr<ApiRequests> {
  return {value : {typeRef : {kind: "reference", value : snApiRequests}, parameters : []}};
}

export interface UserProfile {
  id: myc_scoring_db.AppUserId;
  fullname: string;
  email: string;
  isAdmin: boolean;
}

export function makeUserProfile(
  input: {
    id: myc_scoring_db.AppUserId,
    fullname: string,
    email: string,
    isAdmin: boolean,
  }
): UserProfile {
  return {
    id: input.id,
    fullname: input.fullname,
    email: input.email,
    isAdmin: input.isAdmin,
  };
}

const UserProfile_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"AppUserId"}},"parameters":[]}},{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"isAdmin","default":{"kind":"nothing"},"name":"isAdmin","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"UserProfile","version":{"kind":"nothing"}}};

export const snUserProfile: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"UserProfile"};

export function texprUserProfile(): ADL.ATypeExpr<UserProfile> {
  return {value : {typeRef : {kind: "reference", value : snUserProfile}, parameters : []}};
}

/**
 * Details for a user
 */
export interface UserReq {
  fullname: string;
  email: string;
  password: string;
}

export function makeUserReq(
  input: {
    fullname: string,
    email: string,
    password: string,
  }
): UserReq {
  return {
    fullname: input.fullname,
    email: input.email,
    password: input.password,
  };
}

const UserReq_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details for a user\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"password","default":{"kind":"nothing"},"name":"password","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"UserReq","version":{"kind":"nothing"}}};

export const snUserReq: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"UserReq"};

export function texprUserReq(): ADL.ATypeExpr<UserReq> {
  return {value : {typeRef : {kind: "reference", value : snUserReq}, parameters : []}};
}

export interface LoginReq {
  email: common_strings.StringNE;
  password: common_strings.StringNE;
}

export function makeLoginReq(
  input: {
    email: common_strings.StringNE,
    password: common_strings.StringNE,
  }
): LoginReq {
  return {
    email: input.email,
    password: input.password,
  };
}

const LoginReq_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"password","default":{"kind":"nothing"},"name":"password","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"LoginReq","version":{"kind":"nothing"}}};

export const snLoginReq: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"LoginReq"};

export function texprLoginReq(): ADL.ATypeExpr<LoginReq> {
  return {value : {typeRef : {kind: "reference", value : snLoginReq}, parameters : []}};
}

export interface LoginResp_AccessToken {
  kind: 'accessToken';
  value: common_strings.StringNE;
}
export interface LoginResp_InvalidCredentials {
  kind: 'invalidCredentials';
}

export type LoginResp = LoginResp_AccessToken | LoginResp_InvalidCredentials;

export interface LoginRespOpts {
  accessToken: common_strings.StringNE;
  invalidCredentials: null;
}

export function makeLoginResp<K extends keyof LoginRespOpts>(kind: K, value: LoginRespOpts[K]) { return {kind, value}; }

const LoginResp_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"accessToken","default":{"kind":"nothing"},"name":"accessToken","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"invalidCredentials","default":{"kind":"nothing"},"name":"invalidCredentials","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"LoginResp","version":{"kind":"nothing"}}};

export const snLoginResp: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"LoginResp"};

export function texprLoginResp(): ADL.ATypeExpr<LoginResp> {
  return {value : {typeRef : {kind: "reference", value : snLoginResp}, parameters : []}};
}

export interface SetPasswordReq {
  id: common_db.DbKey<myc_scoring_db.AppUser>;
  password: string;
}

export function makeSetPasswordReq(
  input: {
    id: common_db.DbKey<myc_scoring_db.AppUser>,
    password: string,
  }
): SetPasswordReq {
  return {
    id: input.id,
    password: input.password,
  };
}

const SetPasswordReq_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"password","default":{"kind":"nothing"},"name":"password","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"SetPasswordReq","version":{"kind":"nothing"}}};

export const snSetPasswordReq: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"SetPasswordReq"};

export function texprSetPasswordReq(): ADL.ATypeExpr<SetPasswordReq> {
  return {value : {typeRef : {kind: "reference", value : snSetPasswordReq}, parameters : []}};
}

export interface SetPasswordResp_FailPasswordInvalid {
  kind: 'failPasswordInvalid';
  value: string;
}
export interface SetPasswordResp_Success {
  kind: 'success';
}

export type SetPasswordResp = SetPasswordResp_FailPasswordInvalid | SetPasswordResp_Success;

export interface SetPasswordRespOpts {
  failPasswordInvalid: string;
  success: null;
}

export function makeSetPasswordResp<K extends keyof SetPasswordRespOpts>(kind: K, value: SetPasswordRespOpts[K]) { return {kind, value}; }

const SetPasswordResp_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"failPasswordInvalid","default":{"kind":"nothing"},"name":"failPasswordInvalid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SetPasswordResp","version":{"kind":"nothing"}}};

export const snSetPasswordResp: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"SetPasswordResp"};

export function texprSetPasswordResp(): ADL.ATypeExpr<SetPasswordResp> {
  return {value : {typeRef : {kind: "reference", value : snSetPasswordResp}, parameters : []}};
}

export interface SeasonDetails {
  season: common_db.WithDbId<myc_scoring_db.Season>;
  series: common_db.WithDbId<myc_scoring_db.Series>[];
}

export function makeSeasonDetails(
  input: {
    season: common_db.WithDbId<myc_scoring_db.Season>,
    series: common_db.WithDbId<myc_scoring_db.Series>[],
  }
): SeasonDetails {
  return {
    season: input.season,
    series: input.series,
  };
}

const SeasonDetails_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"season","default":{"kind":"nothing"},"name":"season","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Season"}},"parameters":[]}]}},{"annotations":[],"serializedName":"series","default":{"kind":"nothing"},"name":"series","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Series"}},"parameters":[]}]}]}}]}},"name":"SeasonDetails","version":{"kind":"nothing"}}};

export const snSeasonDetails: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"SeasonDetails"};

export function texprSeasonDetails(): ADL.ATypeExpr<SeasonDetails> {
  return {value : {typeRef : {kind: "reference", value : snSeasonDetails}, parameters : []}};
}

export interface RaceScheduleEntry {
  raceId: myc_scoring_db.RaceId;
  date: common.LocalDate;
  raceNumber: number;
  events: common_db.WithDbId<myc_scoring_db.Event>[];
  dutyOfficer: string;
}

export function makeRaceScheduleEntry(
  input: {
    raceId: myc_scoring_db.RaceId,
    date: common.LocalDate,
    raceNumber: number,
    events: common_db.WithDbId<myc_scoring_db.Event>[],
    dutyOfficer: string,
  }
): RaceScheduleEntry {
  return {
    raceId: input.raceId,
    date: input.date,
    raceNumber: input.raceNumber,
    events: input.events,
    dutyOfficer: input.dutyOfficer,
  };
}

const RaceScheduleEntry_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"raceId","default":{"kind":"nothing"},"name":"raceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"RaceId"}},"parameters":[]}},{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"raceNumber","default":{"kind":"nothing"},"name":"raceNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Word8"},"parameters":[]}},{"annotations":[],"serializedName":"events","default":{"kind":"nothing"},"name":"events","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Event"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"dutyOfficer","default":{"kind":"nothing"},"name":"dutyOfficer","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"RaceScheduleEntry","version":{"kind":"nothing"}}};

export const snRaceScheduleEntry: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"RaceScheduleEntry"};

export function texprRaceScheduleEntry(): ADL.ATypeExpr<RaceScheduleEntry> {
  return {value : {typeRef : {kind: "reference", value : snRaceScheduleEntry}, parameters : []}};
}

export interface RaceEntrant {
  entrant: common_db.WithDbId<myc_scoring_db.Entrant>;
  handicap: number;
  handicapSecs: number;
}

export function makeRaceEntrant(
  input: {
    entrant: common_db.WithDbId<myc_scoring_db.Entrant>,
    handicap: number,
    handicapSecs: number,
  }
): RaceEntrant {
  return {
    entrant: input.entrant,
    handicap: input.handicap,
    handicapSecs: input.handicapSecs,
  };
}

const RaceEntrant_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"entrant","default":{"kind":"nothing"},"name":"entrant","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Entrant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"handicap","default":{"kind":"nothing"},"name":"handicap","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"handicapSecs","default":{"kind":"nothing"},"name":"handicapSecs","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"RaceEntrant","version":{"kind":"nothing"}}};

export const snRaceEntrant: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"RaceEntrant"};

export function texprRaceEntrant(): ADL.ATypeExpr<RaceEntrant> {
  return {value : {typeRef : {kind: "reference", value : snRaceEntrant}, parameters : []}};
}

export interface RaceScheduleResp {
  season: myc_scoring_db.Season;
  races: RaceScheduleEntry[];
  calendarEntries: myc_scoring_db.CalendarEntry[];
}

export function makeRaceScheduleResp(
  input: {
    season: myc_scoring_db.Season,
    races: RaceScheduleEntry[],
    calendarEntries: myc_scoring_db.CalendarEntry[],
  }
): RaceScheduleResp {
  return {
    season: input.season,
    races: input.races,
    calendarEntries: input.calendarEntries,
  };
}

const RaceScheduleResp_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"season","default":{"kind":"nothing"},"name":"season","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Season"}},"parameters":[]}},{"annotations":[],"serializedName":"races","default":{"kind":"nothing"},"name":"races","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"RaceScheduleEntry"}},"parameters":[]}]}},{"annotations":[],"serializedName":"calendarEntries","default":{"kind":"nothing"},"name":"calendarEntries","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"CalendarEntry"}},"parameters":[]}]}}]}},"name":"RaceScheduleResp","version":{"kind":"nothing"}}};

export const snRaceScheduleResp: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"RaceScheduleResp"};

export function texprRaceScheduleResp(): ADL.ATypeExpr<RaceScheduleResp> {
  return {value : {typeRef : {kind: "reference", value : snRaceScheduleResp}, parameters : []}};
}

export interface EntrantRaceResult {
  entrantId: common_db.DbKey<myc_scoring_db.Entrant>;
  result: myc_scoring_db.Result<common.LocalTime>;
}

export function makeEntrantRaceResult(
  input: {
    entrantId: common_db.DbKey<myc_scoring_db.Entrant>,
    result: myc_scoring_db.Result<common.LocalTime>,
  }
): EntrantRaceResult {
  return {
    entrantId: input.entrantId,
    result: input.result,
  };
}

const EntrantRaceResult_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"entrantId","default":{"kind":"nothing"},"name":"entrantId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Entrant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"result","default":{"kind":"nothing"},"name":"result","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Result"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}]}}]}},"name":"EntrantRaceResult","version":{"kind":"nothing"}}};

export const snEntrantRaceResult: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"EntrantRaceResult"};

export function texprEntrantRaceResult(): ADL.ATypeExpr<EntrantRaceResult> {
  return {value : {typeRef : {kind: "reference", value : snEntrantRaceResult}, parameters : []}};
}

export interface RaceStartDetails {
  date: common.LocalDate;
  startTime: common.LocalTime;
  conditions: common_strings.StringML;
  notes: common_strings.StringML;
  abandoned: boolean;
}

export function makeRaceStartDetails(
  input: {
    date: common.LocalDate,
    startTime: common.LocalTime,
    conditions: common_strings.StringML,
    notes: common_strings.StringML,
    abandoned: boolean,
  }
): RaceStartDetails {
  return {
    date: input.date,
    startTime: input.startTime,
    conditions: input.conditions,
    notes: input.notes,
    abandoned: input.abandoned,
  };
}

const RaceStartDetails_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"startTime","default":{"kind":"nothing"},"name":"startTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}},{"annotations":[],"serializedName":"conditions","default":{"kind":"nothing"},"name":"conditions","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringML"}},"parameters":[]}},{"annotations":[],"serializedName":"notes","default":{"kind":"nothing"},"name":"notes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringML"}},"parameters":[]}},{"annotations":[],"serializedName":"abandoned","default":{"kind":"nothing"},"name":"abandoned","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"RaceStartDetails","version":{"kind":"nothing"}}};

export const snRaceStartDetails: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"RaceStartDetails"};

export function texprRaceStartDetails(): ADL.ATypeExpr<RaceStartDetails> {
  return {value : {typeRef : {kind: "reference", value : snRaceStartDetails}, parameters : []}};
}

export interface GetRaceResultsResp {
  scheduledDate: common.LocalDate;
  events: common_db.WithDbId<myc_scoring_db.Event>[];
  startDetails: (RaceStartDetails|null);
  results: EntrantRaceResult[];
}

export function makeGetRaceResultsResp(
  input: {
    scheduledDate: common.LocalDate,
    events: common_db.WithDbId<myc_scoring_db.Event>[],
    startDetails: (RaceStartDetails|null),
    results: EntrantRaceResult[],
  }
): GetRaceResultsResp {
  return {
    scheduledDate: input.scheduledDate,
    events: input.events,
    startDetails: input.startDetails,
    results: input.results,
  };
}

const GetRaceResultsResp_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"scheduledDate","default":{"kind":"nothing"},"name":"scheduledDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"events","default":{"kind":"nothing"},"name":"events","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Event"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"startDetails","default":{"kind":"nothing"},"name":"startDetails","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"RaceStartDetails"}},"parameters":[]}]}},{"annotations":[],"serializedName":"results","default":{"kind":"nothing"},"name":"results","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"EntrantRaceResult"}},"parameters":[]}]}}]}},"name":"GetRaceResultsResp","version":{"kind":"nothing"}}};

export const snGetRaceResultsResp: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"GetRaceResultsResp"};

export function texprGetRaceResultsResp(): ADL.ATypeExpr<GetRaceResultsResp> {
  return {value : {typeRef : {kind: "reference", value : snGetRaceResultsResp}, parameters : []}};
}

export interface EventResults {
  date: common.LocalDate;
  startTime: common.LocalTime;
  abbreviation: common_strings.StringNE;
  conditions: common_strings.StringML;
  isHandicap: boolean;
  abandoned: boolean;
  raceType: myc_scoring_db.RaceType;
  results: myc_scoring_db.EventResult[];
}

export function makeEventResults(
  input: {
    date: common.LocalDate,
    startTime: common.LocalTime,
    abbreviation: common_strings.StringNE,
    conditions: common_strings.StringML,
    isHandicap: boolean,
    abandoned: boolean,
    raceType: myc_scoring_db.RaceType,
    results: myc_scoring_db.EventResult[],
  }
): EventResults {
  return {
    date: input.date,
    startTime: input.startTime,
    abbreviation: input.abbreviation,
    conditions: input.conditions,
    isHandicap: input.isHandicap,
    abandoned: input.abandoned,
    raceType: input.raceType,
    results: input.results,
  };
}

const EventResults_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"startTime","default":{"kind":"nothing"},"name":"startTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}},{"annotations":[],"serializedName":"abbreviation","default":{"kind":"nothing"},"name":"abbreviation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"conditions","default":{"kind":"nothing"},"name":"conditions","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringML"}},"parameters":[]}},{"annotations":[],"serializedName":"isHandicap","default":{"kind":"nothing"},"name":"isHandicap","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"abandoned","default":{"kind":"nothing"},"name":"abandoned","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"raceType","default":{"kind":"nothing"},"name":"raceType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"RaceType"}},"parameters":[]}},{"annotations":[],"serializedName":"results","default":{"kind":"nothing"},"name":"results","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"EventResult"}},"parameters":[]}]}}]}},"name":"EventResults","version":{"kind":"nothing"}}};

export const snEventResults: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"EventResults"};

export function texprEventResults(): ADL.ATypeExpr<EventResults> {
  return {value : {typeRef : {kind: "reference", value : snEventResults}, parameters : []}};
}

export type GetEventResultsResp = (EventResults|null);

const GetEventResultsResp_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"EventResults"}},"parameters":[]}]}}},"name":"GetEventResultsResp","version":{"kind":"nothing"}}};

export const snGetEventResultsResp: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"GetEventResultsResp"};

export function texprGetEventResultsResp(): ADL.ATypeExpr<GetEventResultsResp> {
  return {value : {typeRef : {kind: "reference", value : snGetEventResultsResp}, parameters : []}};
}

export interface EntrantSeriesResult {
  entrantId: myc_scoring_db.EntrantId;
  eventId: myc_scoring_db.EventId;
  score: number;
}

export function makeEntrantSeriesResult(
  input: {
    entrantId: myc_scoring_db.EntrantId,
    eventId: myc_scoring_db.EventId,
    score: number,
  }
): EntrantSeriesResult {
  return {
    entrantId: input.entrantId,
    eventId: input.eventId,
    score: input.score,
  };
}

const EntrantSeriesResult_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"entrantId","default":{"kind":"nothing"},"name":"entrantId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"EntrantId"}},"parameters":[]}},{"annotations":[],"serializedName":"eventId","default":{"kind":"nothing"},"name":"eventId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"EventId"}},"parameters":[]}},{"annotations":[],"serializedName":"score","default":{"kind":"nothing"},"name":"score","typeExpr":{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}}]}},"name":"EntrantSeriesResult","version":{"kind":"nothing"}}};

export const snEntrantSeriesResult: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"EntrantSeriesResult"};

export function texprEntrantSeriesResult(): ADL.ATypeExpr<EntrantSeriesResult> {
  return {value : {typeRef : {kind: "reference", value : snEntrantSeriesResult}, parameters : []}};
}

export interface GetSeriesResultsResp {
  season: common_db.WithDbId<myc_scoring_db.Season>;
  series: common_db.WithDbId<myc_scoring_db.Series>;
  events: common_db.WithDbId<myc_scoring_db.Event>[];
  entrants: common_db.WithDbId<myc_scoring_db.Entrant>[];
  results: EntrantSeriesResult[];
}

export function makeGetSeriesResultsResp(
  input: {
    season: common_db.WithDbId<myc_scoring_db.Season>,
    series: common_db.WithDbId<myc_scoring_db.Series>,
    events: common_db.WithDbId<myc_scoring_db.Event>[],
    entrants: common_db.WithDbId<myc_scoring_db.Entrant>[],
    results: EntrantSeriesResult[],
  }
): GetSeriesResultsResp {
  return {
    season: input.season,
    series: input.series,
    events: input.events,
    entrants: input.entrants,
    results: input.results,
  };
}

const GetSeriesResultsResp_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"season","default":{"kind":"nothing"},"name":"season","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Season"}},"parameters":[]}]}},{"annotations":[],"serializedName":"series","default":{"kind":"nothing"},"name":"series","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Series"}},"parameters":[]}]}},{"annotations":[],"serializedName":"events","default":{"kind":"nothing"},"name":"events","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Event"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"entrants","default":{"kind":"nothing"},"name":"entrants","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Entrant"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"results","default":{"kind":"nothing"},"name":"results","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"EntrantSeriesResult"}},"parameters":[]}]}}]}},"name":"GetSeriesResultsResp","version":{"kind":"nothing"}}};

export const snGetSeriesResultsResp: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"GetSeriesResultsResp"};

export function texprGetSeriesResultsResp(): ADL.ATypeExpr<GetSeriesResultsResp> {
  return {value : {typeRef : {kind: "reference", value : snGetSeriesResultsResp}, parameters : []}};
}

export interface UpdateRaceResultsReq {
  raceId: myc_scoring_db.RaceId;
  startDetails: RaceStartDetails;
  results: EntrantRaceResult[];
}

export function makeUpdateRaceResultsReq(
  input: {
    raceId: myc_scoring_db.RaceId,
    startDetails: RaceStartDetails,
    results: EntrantRaceResult[],
  }
): UpdateRaceResultsReq {
  return {
    raceId: input.raceId,
    startDetails: input.startDetails,
    results: input.results,
  };
}

const UpdateRaceResultsReq_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"raceId","default":{"kind":"nothing"},"name":"raceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"RaceId"}},"parameters":[]}},{"annotations":[],"serializedName":"startDetails","default":{"kind":"nothing"},"name":"startDetails","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"RaceStartDetails"}},"parameters":[]}},{"annotations":[],"serializedName":"results","default":{"kind":"nothing"},"name":"results","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.api","name":"EntrantRaceResult"}},"parameters":[]}]}}]}},"name":"UpdateRaceResultsReq","version":{"kind":"nothing"}}};

export const snUpdateRaceResultsReq: ADL.ScopedName = {moduleName:"myc.scoring.api", name:"UpdateRaceResultsReq"};

export function texprUpdateRaceResultsReq(): ADL.ATypeExpr<UpdateRaceResultsReq> {
  return {value : {typeRef : {kind: "reference", value : snUpdateRaceResultsReq}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "myc.scoring.api.ApiRequests" : ApiRequests_AST,
  "myc.scoring.api.UserProfile" : UserProfile_AST,
  "myc.scoring.api.UserReq" : UserReq_AST,
  "myc.scoring.api.LoginReq" : LoginReq_AST,
  "myc.scoring.api.LoginResp" : LoginResp_AST,
  "myc.scoring.api.SetPasswordReq" : SetPasswordReq_AST,
  "myc.scoring.api.SetPasswordResp" : SetPasswordResp_AST,
  "myc.scoring.api.SeasonDetails" : SeasonDetails_AST,
  "myc.scoring.api.RaceScheduleEntry" : RaceScheduleEntry_AST,
  "myc.scoring.api.RaceEntrant" : RaceEntrant_AST,
  "myc.scoring.api.RaceScheduleResp" : RaceScheduleResp_AST,
  "myc.scoring.api.EntrantRaceResult" : EntrantRaceResult_AST,
  "myc.scoring.api.RaceStartDetails" : RaceStartDetails_AST,
  "myc.scoring.api.GetRaceResultsResp" : GetRaceResultsResp_AST,
  "myc.scoring.api.EventResults" : EventResults_AST,
  "myc.scoring.api.GetEventResultsResp" : GetEventResultsResp_AST,
  "myc.scoring.api.EntrantSeriesResult" : EntrantSeriesResult_AST,
  "myc.scoring.api.GetSeriesResultsResp" : GetSeriesResultsResp_AST,
  "myc.scoring.api.UpdateRaceResultsReq" : UpdateRaceResultsReq_AST
};
